import * as React from 'react'
import { DeleteAccountModal } from '../DeleteAccountModal'
import { DeleteAccountSuccessModal } from '../DeleteAccountSuccessModal'
export interface DeleteAccountModalExperienceProps {
  onClose: () => void
}

export const DeleteAccountModalExperience = ({
  onClose
}: DeleteAccountModalExperienceProps) => {
  const [hasDeletedAccount, setHasDeletedAccount] = React.useState(false)
  if (hasDeletedAccount) {
    return <DeleteAccountSuccessModal onAccept={onClose} />
  }
  return (
    <DeleteAccountModal
      onClose={onClose}
      onSuccess={() => setHasDeletedAccount(true)}
    />
  )
}
